/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
enum PAGE {
    DECISION_BOX = 'decisionBox',
    EPS = 'eps',
    LOGOUT = 'logout',
    LOGON = 'logon',
    MESSAGE_BOX = 'messageBox',
    OAUTH_AUTHZ = 'oauthAuthz',
    TAS_AUTH = 'tasAuth',
    TAS_DEVICE_REGISTRATION = 'tasDeviceRegistration',
    WEBTOP = 'webtop',
}

export default PAGE;
